
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"25","cy":"25","r":"2","fill":"#3A4249"}}),_c('circle',{attrs:{"cx":"39","cy":"25","r":"2","fill":"#3A4249"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M61 46V22c0-6.08-4.92-11-11-11h-2.42c-.78-1.37-1.74-2.62-2.85-3.73A17.983 17.983 0 0032 2c-9.94 0-18 8.06-18 18h-2a4 4 0 000 8h2v-3.463l4.59 5.355a1 1 0 001.519-1.302l-4.699-5.481A1 1 0 0014 23v-2c7.19 0 13-4.92 13-11 0 6.08 10.29 11 23 11v-1h2c2.21 0 4 1.79 4 4s-1.79 4-4 4h-2v1a1 1 0 00-1.327.489L44 39.612V38a1 1 0 01-.784 1.177l-3.039.607a.999.999 0 11-.393-1.961l3.039-.607A.999.999 0 0144 38v-3.999a1 1 0 01-1.177.784l-3.039-.607a1.001 1.001 0 01.393-1.962l3.039.607c.512.102.84.581.784 1.092V30l-12-2-12 2v4a1 1 0 01.784-1.177l3.039-.607a.999.999 0 11.393 1.961l-3.039.607A.999.999 0 0120 34v5.614l-4.673-10.125A.998.998 0 0014.001 29H14a1 1 0 00-.489 1.327l5.162 11.184A1 1 0 0020 42a20.004 20.004 0 004 2.322v2.428c0 1.9-1.33 3.53-3.18 3.92l-7.43 1.57-2.2.46c-1.91.4-3.65 1.3-5.07 2.56A11.03 11.03 0 003 60v2h58v-2a11.03 11.03 0 00-3.12-4.74 11.062 11.062 0 00-5.07-2.56l-2.2-.46-7.43-1.57A4.004 4.004 0 0140 46.75v-2.428A20.004 20.004 0 0044 42a1 1 0 001.327-.489L50 31.388V35c0 6.08 4.92 11 11 11zm-40.216-6.823a1 1 0 11.393-1.961l3.039.607a1 1 0 01-.393 1.961l-3.039-.607zM42.77 52.52l3.3.69c-3.73 2.32-8.79 3.68-14.07 3.68s-10.34-1.36-14.07-3.68l3.3-.69C24 51.93 26 49.46 26 46.64v-1.569a20.02 20.02 0 0012 0v1.569c0 2.82 2 5.29 4.77 5.88z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M45.4 29.8l4.8-6.4a1 1 0 00-1.6-1.2l-4.8 6.4a1 1 0 001.6 1.2z"}})])
          )
        }
      }
    